import { isArray, isFunction, isObject } from "lodash";
let users = [];

let subscriptions = [];

export function subscribe(cb) {
    subscriptions.push(cb);
}

function dispatch() {
    subscriptions.forEach((s) => s(users));
}

export function enrollUsers(users, devices) {
    if (!isArray(users)) {
        users = [users];
    }
    if (!isArray(devices)) {
        devices = [devices];
    }

    var data = {
        UserIds: users,
        DeviceIds: devices,
    };

    return fetch(`/api/Devices/$enroll`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify(data),
    }).then((res) => res.json());
}

export function getUsers(subscription) {
    let params = { archive: false };

    if (isFunction(subscription)) subscribe(subscription);
    if (isObject(subscription)) {
        params = subscription;
    }

    return fetch(`/api/Users?${params.archive ? "includeArchived=true" : ""}`)
        .then((res) => res.json())
        .then((result) => {
            users = result;
            dispatch();
            return result;
        });
}

export function getUser(id) {
    return fetch(`/api/Users/${id}`)
        .then((res) => res.json())
        .then((result) => {
            users = users.map((user) => (user.userId == result.userId ? result : user));
            dispatch();
            return result;
        });
}

export function updateUser(id, user) {
    return fetch(`/api/Users/${id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify(user),
    }).then(() => getUsers());
}

export function archiveUser(id, user) {
    user.archived = true;
    return fetch(`/api/Users/${id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify(user),
    });
}

export function unarchiveUser(id, user) {
    user.archived = false;
    return fetch(`/api/Users/${id}`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify(user),
    });
}

export function deleteUser(id) {
    return fetch(`/api/Users/${id}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
    });
}

export function createUser(user) {
    return fetch("/api/Users", {
        method: "POST",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
        body: JSON.stringify(user),
    }).then((res) => (res.status == 201 ? res.json() : Promise.reject(res)));
}

export function toggleShiftUser(user, shift) {
    return fetch(`/api/Users/${user}/Shifts/${shift}/$toggle`, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
    }).then((res) => res.json());
}
export function addShiftUser(user, shift) {
    return fetch(`/api/Users/${user}/Shifts/${shift}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
    }).then((res) => res.json());
}
export function removeShiftUser(user, shift) {
    return fetch(`/api/Users/${user}/Shifts/${shift}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
    }).then((res) => res.json());
}

export function getUsersWithoutBiometrics() {
    return fetch(`/api/Users/$withoutBiometricData`)
        .then((res) => res.json())
        .then((result) => {
            return result;
        });
}
export function getUsersWithoutCustomIds() {
    return fetch(`/api/Users/$withoutCustomIds`)
        .then((res) => res.json())
        .then((result) => {
            return result;
        });
}
export function getUsersWithoutNames() {
    return fetch(`/api/Users/$withoutNames`)
        .then((res) => res.json())
        .then((result) => {
            return result;
        });
}
export function getUsersWithoutShifts() {
    return fetch(`/api/Users/$withoutShifts`)
        .then((res) => res.json())
        .then((result) => {
            return result;
        });
}

export function getUsersWithLateCheckinsForDate(date) {
    return fetch(`/api/Users/$lateCheckins?date=${date}`)
        .then((res) => res.json())
        .then((result) => {
            return result;
        });
}

export function getUsersWithoutCheckoutsForDate(date) {
    return fetch(`/api/Users/$noCheckouts?date=${date}`)
        .then((res) => res.json())
        .then((result) => {
            return result;
        });
}

export function getUsersWithoutCheckinsForDate(date, groups) {
    return fetch(`/api/Users/$noCheckins?date=${date}&groups=${groups}`)
        .then((res) => res.json())
        .then((result) => {
            return result;
        });
}

export function getUsersWorkingShort(date, groups) {
    return fetch(`/api/Users/$shortHours?date=${date}&groups=${groups}`)
        .then((res) => res.json())
        .then((result) => {
            return result;
        });
}

export function getExpiredUsers() {
    return fetch(`/api/Users/$expired`)
        .then((res) => res.json())
        .then((result) => {
            return result;
        });
}

export function getUsersExpiringSoon() {
    return fetch(`/api/Users/$expiresSoon`)
        .then((res) => res.json())
        .then((result) => {
            return result;
        });
}

export function cleanUserBioData(user) {
    return fetch(`/api/BiometricData/Users/${user}/$clean`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json; charset=utf-8",
        },
    }).then((res) => res.json());
}

export default {
    getUsers,
    enrollUsers,
};
